import React from 'react';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMGuideAppDownload extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }


  render() {
    return(
      <div className="reserve-complete__app-appeal">
        <img src={SMRailsBridge.assetPath.appIcon} alt="この後の流れにはアプリのご利用が便利です" width="60" height="60" />
        <h2 className="reserve-complete__app-appeal-title">この後の流れには<br />アプリのご利用が便利です</h2>
        <div className="row">
          <div className="col-sm-12 col-md-4">
            <h3 className="reserve-complete__app-appeal-point">ゲスト/ホスト間の連絡が<br />スムーズに！</h3>
            <img src={SMRailsBridge.assetPath.appPoint1} alt="ゲスト/ホスト間の連絡がスムーズに！" className="reserve-complete__app-appeal-img" width="130" height="130" />
            <p className="reserve-complete__app-appeal-content">予約完了時やメッセージ受信時など<br />リアルタイムに通知でお知らせ</p>
          </div>
          <div className="col-sm-12 col-md-4">
            <h3 className="reserve-complete__app-appeal-point">メッセージが<br />送りやすい！</h3>
            <img src={SMRailsBridge.assetPath.appPoint2} alt="予約完了時やメッセージ受信時などリアルタイムに通知でお知らせ" className="reserve-complete__app-appeal-img" width="130" height="130" />
            <p className="reserve-complete__app-appeal-content">メッセージの送受信も<br />チャットアプリのようにらくらく</p>
          </div>

          <div className="col-sm-12 col-md-4">
            <h3 className="reserve-complete__app-appeal-point">当日の予約確認も<br />カンタン！</h3>
            <img src={SMRailsBridge.assetPath.appPoint3} alt="当日の予約確認もカンタン！" className="reserve-complete__app-appeal-img" width="130" height="130" />
            <p className="reserve-complete__app-appeal-content">予約内容やスペースの場所も<br />すぐに確認できる</p>
          </div>
        </div>
        <h3 className="reserve-complete__app-appeal-download">いますぐダウンロード</h3>
        <a href="https://itunes.apple.com/app/apple-store/id973447544?pt=117136620&ct=Inquiry_banner_bottom&mt=8">
          <img src={SMRailsBridge.assetPath.bannerAppstore} alt="Download on the App Srore" className="reserve-complete__app-appeal-banner" width="180" height="53" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.spacemarket&referrer=utm_source%3Dspacemarket.com%252Fspaces%252FInquiry%26utm_medium%3Dreferral%26utm_content%3Dbanner_bottom">
         <img src={SMRailsBridge.assetPath.bannerGoogleplay} alt="GET IT ON Google Play" className="reserve-complete__app-appeal-banner" width="180" height="53" />
        </a>
      </div>
    );
  }

}

export default SMGuideAppDownload;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMGuideAppDownload.jsx